export default {
  Report: {
    Apply: "https://www.zichanxinxi.com:11123/api/report/apply",
    CheckPayed: "https://www.zichanxinxi.com:11123/api/pay/checkpayed",
    GeneReport: "https://www.zichanxinxi.com:11123/api/report/gene"
  }
};
